<template>
  <div class="login">
    <div class="login__form-admin">
       <h2 class="login__title">Bienvenido</h2>
      <p class="login__description">Ingresa al administrador para gestionar las solicitudes de admisión.</p>
      <!-- <img
        src="https://kiritek-web-documents.s3-us-west-2.amazonaws.com/trust1/logot1.png"
        style="width: 30%; margin-bottom: 4rem;"
        alt="logo-t1"
      /> -->

      <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
        <label class="form__label">Correo electrónico:</label>
        <input @keyup.enter="handleAuth" v-model="email" type="email" class="form__input" />
        <validation-error :validation="$v.email"></validation-error>
      </div>
      <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
        <label class="form__label">Contraseña:</label>
        <input
          @keyup.enter="handleAuth"
          :type="passwordVisible"
          v-model="password"
          class="form__input input-password"
        />
        <img
          @mousedown="togglePwdIcon(true)"
          @mouseup="togglePwdIcon(false)"
          @mouseleave="togglePwdIcon(false)"
          :src="'/img/icons/'+showPasswordIcon"
          class="show-password"
        />
        <validation-error :validation="$v.password"></validation-error>
      </div>
      <div class="form__group">
        <btn @onClick="handleAuth" v-if="loggin" type="primary-block" text="Iniciar Sesión" />
        <p class="text-primary animated fadeInLeft" v-else>Cargando...</p>
        <p class="forgot-password" @click="$refs.forgotpwd.toggleModal()">¿Olvidaste tu contraseña?</p>
      </div>

      <!-- <form id="formLogin" class="needs-validation" @submit="login">
        <div class="form__group">
          <label class="form__label">Correo electrónico:</label>
          <input
            type="email"
            class="form__input"
            required
            pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            v-model="email"
          />
        </div>
        <div class="alert alert-danger alert-dismissible" v-show="badCredentialsUser">
          <button type="button" class="close" @click="badCredentialsStatus">×</button>
          <h4>
            <i class="icon fa fa-ban"></i> Error
          </h4>Correo de usuario incorrecto.
        </div>
        <div class="form__group">
          <label class="form__label">Contraseña:</label>
          <input :type="passwordVisible" class="form__input input-password" required v-model="pass" />
          <img
            @mousedown="togglePwdIcon(true)"
            @mouseup="togglePwdIcon(false)"
            @mouseleave="togglePwdIcon(false)"
            :src="'/img/icons/'+showPasswordIcon"
            class="show-password"
          />
        </div>
        <div class="alert alert-danger alert-dismissible" v-show="badCredentialsPass">
          <button type="button" class="close" @click="badCredentialsStatus">×</button>
          <h4>
            <i class="icon fa fa-ban"></i> Error
          </h4>Contraseña incorrecta.
        </div>
        <div class="form__group">
          <btn type="primary-block" text="Iniciar Sesión" />
          <p
            class="forgot-password"
            @click="$refs.forgotpwd.toggleModal()"
          >¿Olvidaste tu contraseña?</p>
        </div>
      </form>-->
    </div>
    <div class="login__bg-admin"></div>
    <Loader v-show="isLoading" />
    <Popup ref="forgotpwd" size="sm">
      <h3 class="text-center title-forgot-pwd">¿Olvidaste tu contraseña?</h3>
      <p
        class="forgot-pwd-text"
      >No te preocupes, ingresa a tu correo y un link de recuperación será enviado a tu bandeja de entrada.</p>
      <div class="form">
        <div class="form__group" style="margin-bottom: 0;">
          <label class="form__label">Correo electrónico</label>
          <input v-model="recoveryEmail" type="email" class="form__input" />
          <validation-error :validation="$v.recoveryEmail"></validation-error>
        </div>
        <div class="form__group text-right pt-5">
          <btn
            class="text-center btn-inline"
            type="default"
            text="Cancelar"
            @onClick="$refs.forgotpwd.toggleModal()"
          />
          <btn
            class="text-center btn-inline"
            type="primary"
            text="Enviar"
            @onClick="sendPwdConfirm"
          />
        </div>
      </div>
    </Popup>
    <Popup ref="resetpwdsent" size="sm">
      <div class="text-center">
        <h3 class="text-center title-forgot-pwd mb-3">Email enviado</h3>
        <p
          class="forgot-pwd-text"
        >Ingresa a tu correo electrónico, un link de recuperación será enviado a tu bandeja de entrada.</p>
        <img src="/img/icons/email-sent.svg" alt />
        <div class="form__group mt-5">
          <btn type="primary-block" text="OK" @onClick="$refs.resetpwdsent.toggleModal()" />
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import Popup from "../core/Popup";
import Btn from "../core/Button";
import Swal from "sweetalert2";
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapActions, mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "./misc/ValidationError";
import Loader from "../core/Loader";

export default {
  name: "LoginAdmin",
  components: {
    Loader,
    mdbContainer,
    mdbRow,
    mdbCol,
    Btn,
    Popup,
    ValidationError
  },
  data() {
    return {
      isLoading: false,
      passwordVisible: "password",
      email: "",
      password: "",
      recoveryEmail: "",
      loggin: true,
      badCredentialsUser: false,
      badCredentialsPass: false
    };
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    },
    recoveryEmail: {
      required,
      email
    }
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
      userType: state => state.auth.userType,
      clubName: state => state.auth.club
    }),
    showPasswordIcon() {
      let icon = "";
      if (this.passwordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    }
  },
  methods: {
    // badCredentialsStatus: function() {
    //   this.badCredentialsUser = false;
    //   this.badCredentialsPass = false;
    // },
    // login(event) {
    //   event.preventDefault();
    //   event.target.classList.add("was-validated");
    // },

    ...mapActions(["authenticate", "logOut", "sendEmailPasswordRecovery"]),
    async logout() {
      await this.logOut();
    },
    async handleAuth() {
      this.$v.password.$touch();
      this.$v.email.$touch();
      if (!this.$v.password.$invalid && !this.$v.email.$invalid) {
        try {
          this.loggin = false;
          await this.authenticate({
            email: this.email,
            password: this.password
          });
          if (this.authenticated) {
            if (this.userType != "APPLICANT") {
              
              if(this.userType == "SUPER_ADMIN" || this.clubName != null){
                this.$router.push("/admin");
                this.$notify.success({
                message:
                  "Bienvenido al administrador del sistema de solicitudes de club de golf",
                position: "bottom right",
                timeOut: 5000
              });
              }
              else{
                 this.loggin = true;
                this.$notify.error({
                message: "No tienes autorización para ingresar a este portal todavia, espera a que te asignen un club",
                position: "top right",
                timeOut: 5000
              });
                this.$store.commit("clearAuthentication")

              }

            } else {
               this.loggin = true;
              this.$notify.error({
                message: "No tienes autorización para ingresar a este portal",
                position: "top right",
                timeOut: 5000
              });
            }
          }
        } catch (e) {
          this.loggin = true;
          this.showFailureMessage = true;
          let emessage = "";
          if (e.response) {
            emessage = e.response.data.error_description;
          }
          this.$notify.error({
            message: emessage,
            position: "top right",
            timeOut: 5000
          });
        }
      }
    },

    togglePwdIcon(icon) {
      if (icon) {
        this.passwordVisible = "text";
      } else {
        this.passwordVisible = "password";
      }
    },
    async sendPwdConfirm() {
      try {
        this.$v.recoveryEmail.$touch();
        if (this.$v.recoveryEmail.$invalid) {
          return;
        }
        this.$refs.forgotpwd.toggleModal();
        this.isLoading = true;
        const params = {
          email: this.recoveryEmail
        };
        const data = await this.sendEmailPasswordRecovery(params);

        if (data.status === 200) {
          this.$refs.resetpwdsent.toggleModal();
        }else {
          this.pushNotifyError();
        }

      }catch (error) {
        if (error && error.response && error.response.status === 404) {
          this.errorMessage();
        } else {
          this.pushNotifyError();
        }
      }finally {
        this.isLoading = false;
        this.recoveryEmail = "";
      }
    },
    errorMessage() {
      Swal.fire({
        title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans,serif; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans,serif; color: #828282'>" +
                "<p>El correo eletrónico que ingreso no existe.</p>" +
                "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block"
        },
        onClose: () => {}
      });
    },
    pushNotifyError(){
      this.$notify.error({
        message: "Ha ocurrido un error, inténtalo más tarde.",
        position: "top right",
        timeOut: 15000
      });
    },
  },
  mounted(){
    this.logout();
  }
};
</script>
<style lang="scss">
$medium-grey: #828282;

.input-password {
  display: inline;
}

.btn-inline {
  display: inline;
  &:not(:last-child) {
    padding-right: 1.5rem;
  }
}

.show-password {
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  padding-top: 1.1rem;
  padding-left: 0.5rem;
  display: inline;
}

.title-forgot-pwd {
  text-transform: uppercase;
  color: $medium-grey;
  font-weight: 400;
  font-family: Josefin Sans;
  font-size: 2rem;
}

.forgot-pwd-text {
  color: $medium-grey;
  font-size: 1.2rem;
  padding: 0.5rem 0.5rem;
  text-align: center;
}
</style>